import React, { useState, useEffect } from 'react';
import '../../styles/pages/_avatarUpload.scss';

// import { DeleteOutlined } from '@ant-design/icons';

const AvatarUpload = ({ image, onUpload, onDelete }) => {
  const [avatar, setAvatar] = useState(null);
  // const [hovered, setHovered] = useState(false);

  useEffect(() => {
    if (!image) return;

    if (typeof image === 'string') {
      setAvatar(image);
      return;
    }
    if (image instanceof File || image instanceof Blob) {
      const objectUrl = URL.createObjectURL(image);
      setAvatar(objectUrl);

      return () => {
        URL.revokeObjectURL(objectUrl);
      };
    }
  }, [image]);
  console.log({ image, avatar });

  const handleImageChange = e => {
    const file = e.target.files?.[0];
    if (!file) return;

    const previewUrl = URL.createObjectURL(file);
    setAvatar(previewUrl);

    if (onUpload) {
      onUpload(file);
    }
  };

  return (
    <div
      id="avatar-upload-container"
      style={{ textAlign: 'center', position: 'relative', width: '176px' }}
      // onMouseEnter={() => setHovered(true)}
      // onMouseLeave={() => setHovered(false)}
    >
      <label htmlFor="avatar-upload">
        <div
          id="avatar-preview"
          style={{
            backgroundImage: avatar ? `url(${avatar})` : 'none',
          }}
        >
          {!avatar && <span id="avatar-text">Upload</span>}
        </div>
      </label>
      <input
        id="avatar-upload"
        type="file"
        accept="image/*"
        style={{ display: 'none' }}
        onChange={handleImageChange}
      />

      {/* {hovered && avatar && (
        <div id="avatar-delete-button" onClick={onDelete}>
          <DeleteOutlined />
          <span>Διαγραφή</span>
        </div>
      )} */}
    </div>
  );
};

export default AvatarUpload;
